import {CommonService} from '../../../services/common.service';
import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatPaginator, MatTableDataSource} from '@angular/material';
import {MatDialogRef} from '@angular/material/dialog';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {UsedBudgetService} from '../../../services/used-budget.service';

@Component({
  templateUrl: './budget-file-info-dialog.component.html'
})
export class BudgetFileInfoDialogComponent implements OnInit {
  @ViewChild('paginator', {static: false}) paginator: MatPaginator;

  private readonly rowId: number;
  public dataSource: MatTableDataSource<any>;
  public displayedColumns: string[];
  public tableHeight: number;

  constructor(private commonService: CommonService,
              private matDialogRef: MatDialogRef<BudgetFileInfoDialogComponent>,
              private toastMessagesService: ToastMessagesService,
              private usedBudgetService: UsedBudgetService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.dataSource = new MatTableDataSource<any>([]);
    this.displayedColumns = [
      'id',
      'sales_group_id',
      'sales_group_description',
      'material_id',
      'material_description',
      'is_led_name',
      'initial_quantity',
      'file_name',
      'category_name'
    ];
    this.tableHeight = window.innerHeight - 320;
    this.rowId = +data.rowId;
  }

  public async ngOnInit(): Promise<void> {
    try {
      await this.initDatabase();
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.error.message);
    } finally {
      this.commonService.setPaginatorTexts(this.paginator);
    }
  }

  async initDatabase() {
    this.dataSource = new MatTableDataSource<any>(await this.usedBudgetService.fetchUploadedBudgetFilesInfo(this.rowId) as any[]);
    this.dataSource.paginator = this.paginator;
  }

  close() {
    this.matDialogRef.close();
  }
}
